import React, {useState, useCallback} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import styled from 'styled-components/native';
import DataState from 'app/src/components/DataState';
// import { ModalContent } from 'app/src/styles/modal';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View, ScrollView } from 'react-native';
import { ContentContainer } from 'app/src/elements';
import SubNav from './SubNav';
import { useNavigate } from '../../../utils/routing';
import { CREATE_RECURRING_SALE } from './queries';
import { ButtonContainer } from './elements';
import moment from 'moment';
import { DAYS_OF_WEEK } from './';

const NewRecurringSale = ({setShowModal, refetch}) => {
  const [submitting, setSubmitting] = useState();
  // const navigate = useNavigate();
  const [createRecurringSale] = useMutation(CREATE_RECURRING_SALE, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    input['frequency'] = parseInt(input['frequency']);
    input['dayOfWeek'] = parseInt(input['dayOfWeek']);
    input['weekOfMonth'] = parseInt(input['weekOfMonth']);
    input['preBidDaysAhead'] = parseInt(input['preBidDaysAhead']);
    input['createDaysAhead'] = parseInt(input['createDaysAhead']);
    createRecurringSale({ variables: input });
  });

  const { control, handleSubmit, register, watch, formState: { errors } } = useForm({
    defaultValues: {
      name: '',
      recurrence: '',
      frequency: '',
      dayOfWeek: '',
      weekOfMonth: '',
      preBidOpenAt: '',
      preBidDaysAhead: '',
      createDaysAhead: '',
      startAt: '',
      endAt: '',
      startOn: ''
    }
  });

  const watchRecurrence = watch('recurrence');

  return (
    <View style={{display: 'flex', flex: 1}}>
      {/* <SubNav /> */}
      {submitting ?
        <DataState.Loading /> :
        <ScrollView>
          <Input.Text
            label="Name:"
            name="name"
            control={control}
            errors={errors}
            {...register("name", {
              required: "Required",
            })}
          />
          <Input.Picker
            label="Recurrence:"
            name="recurrence"
            control={control}
            errors={errors}
            options={['weekly', 'monthly'].map(option => {
              return {value: option, label: option}
            })}
            {...register("recurrence", {
              required: "Required",
            })}
          />
          <Input.Number
            label="Frequency:"
            name="frequency"
            control={control}
            errors={errors}
            {...register("frequency", {
              required: "Required",
            })}
          />
          <Input.Picker
            label="Day of Week:"
            name="dayOfWeek"
            control={control}
            errors={errors}
            options={DAYS_OF_WEEK.map(option => {
              return option
            })}
            {...register("dayOfWeek", {
              required: "Required",
            })}
          />
          {'monthly' === watchRecurrence && (
            <Input.Number
              label="Week of Month:"
              name="weekOfMonth"
              control={control}
              errors={errors}
            />
          )}
          <Input.Time
            label="Pre Bid Open At:"
            name="preBidOpenAt"
            control={control}
            errors={errors}
          />
          <Input.Number
            label="PreBid Days Ahead:"
            name="preBidDaysAhead"
            control={control}
            errors={errors}
          />
          <Input.Number
            label="Create Days Ahead:"
            name="createDaysAhead"
            control={control}
            errors={errors}
          />
          <Input.Time
            label="Start:"
            name="startAt"
            control={control}
            errors={errors}
            {...register("startAt", {
              required: "Required",
            })}
          />
          <Input.Time
            label="End:"
            name="endAt"
            control={control}
            errors={errors}
            {...register("endAt", {
              required: "Required",
            })}
          />
          <Input.Date
            label="Start On:"
            name="startOn"
            control={control}
            errors={errors}
            {...register("startOn", {
              required: "Required",
            })}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button
                label="Create Recurring Sale"
                onPress={handleSubmit(onSubmit)}
                style={{width: 'fit-content'}}
              />
            </ButtonGroup>
          </ButtonContainer>
        </ScrollView>
      }
    </View>
  )
}

export default NewRecurringSale;
